export { DeteriorationModelsList } from './DeteriorationModelsList.component';
